import { useForm } from "react-hook-form";

import { LoginFormValues } from "../types/authForms.types";
import { useLoginSession } from "./useLoginSession";

/** Form state for `LoginNew`, wired to the `useLoginSession` bootstrap. */
export const useLoginViewModel = () => {
  const methods = useForm<LoginFormValues>({ defaultValues: { email: "", password: "" } });
  const { submitLogin, isPending } = useLoginSession();

  return {
    methods,
    onSubmit: methods.handleSubmit(submitLogin),
    isPending
  };
};
